import React from 'react'
import { LoginCallback } from '@okta/okta-react'
import { Switch, Route } from 'react-router-dom'
import styles from './styles.module.less'
import { TransfersPage } from '../Transfers'
import { SearchBar } from '../SearchBar'
import { CashTransfersHome } from '../CashTransfersHome'
import { ApexMenu } from '../ApexMenu'
import { AppHeader } from '../../components/AppHeader'
import { AppFooter } from '../../components/AppFooter'
import { TransferMessages } from '../TransferMessages'
import useInterceptors from '../../hooks/useInterceptors'
import AccountProvider from '../../contexts/AccountProvider'
import { useSetRumUser, clearRumUser } from '../../utils/datadog'
import { ApexLogin } from '../../containers/ApexLogin'
import { useVerifySession, fetchLogout } from 'ui-classic-common-library'

const AppComponent = () => {
  useInterceptors()
  const { isSessionLoading, hasSession } = useVerifySession()
  useSetRumUser(hasSession)
  return (
    <div className={styles.app}>
      <AccountProvider>
        <div className={styles.pageHeader}>
          <AppHeader title='Accounts' />
          <span className='svg-inline'>
            <ApexMenu
              signedIn={hasSession}
              handleSignout={() => {
                fetchLogout().then(() => {
                  window.location.href = '/'
                  clearRumUser()
                })
              }}
            />
          </span>
          {hasSession && <SearchBar />}
          {hasSession && <TransferMessages />}
        </div>

        <div className={styles.mainContent}>
          {hasSession ? (
            <>
              <Route path='/' component={LoginCallback} />
              <Switch>
                <Route path='/transfers/:accountNumber' hasSession={hasSession}>
                  <TransfersPage />
                </Route>
                <Route path='/' hasSession={hasSession}>
                  <CashTransfersHome />
                </Route>
              </Switch>
            </>
          ) : (
            <ApexLogin isSessionLoading={isSessionLoading} />
          )}
        </div>
      </AccountProvider>
      <div className={styles.pageFooter}>
        <AppFooter />
      </div>
    </div>
  )
}

export default AppComponent
